
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User, UserPlus } from 'lucide-react';

interface BillingManager {
  name: string;
  email: string;
  phone?: string;
}

interface BillingManagerProps {
  manager?: BillingManager;
  onBillingManagerChange?: (userId: string) => void;
}

const BillingManager: React.FC<BillingManagerProps> = ({ 
  manager,
  onBillingManagerChange
}) => {
  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-medium flex justify-between items-center">
          <span>Billing Manager</span>
          {onBillingManagerChange && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-8 px-2"
              onClick={() => onBillingManagerChange('')}
            >
              <UserPlus className="h-4 w-4 mr-1" />
              <span>Change</span>
            </Button>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {manager ? (
          <div className="flex items-center space-x-3">
            <div className="bg-blue-100 text-blue-700 rounded-full w-10 h-10 flex items-center justify-center">
              <User size={20} />
            </div>
            <div>
              <div className="font-medium">{manager.name}</div>
              <div className="text-sm text-gray-500">{manager.email}</div>
              {manager.phone && (
                <div className="text-sm text-gray-500">{manager.phone}</div>
              )}
            </div>
          </div>
        ) : (
          <div className="text-muted-foreground text-sm">
            No billing manager assigned. {onBillingManagerChange && 'Click "Change" to assign one.'}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BillingManager;
